/*
================================================================================
|                                                                              |
|  FILE: src/pages/EcoRevivePage.js                                            |
|  PURPOSE: Dedicated page for Project EcoRevive with unique UI design.       |
|                                                                              |
================================================================================
*/
import React from 'react';
import SEO from '../components/common/SEO';
import EcoReviveHero from '../sections/ecorevivepage/EcoReviveHero';
import EcoReviveProjectOverview from '../sections/ecorevivepage/EcoReviveProjectOverview';
import SDGShowcase from '../sections/ecorevivepage/SDGShowcase';
import ImpactMetrics from '../sections/ecorevivepage/ImpactMetrics';
import ProjectCommitment from '../sections/ecorevivepage/ProjectCommitment';

export default function EcoRevivePage() {
    return (
        <main>
            <SEO 
                title="Project EcoRevive - Environmental Restoration Initiative"
                description="Project EcoRevive is Milliardi Energo's flagship environmental restoration initiative, focusing on land reclamation, water purification, and community development in Ghana."
                keywords={[
                    "Project EcoRevive",
                    "environmental restoration",
                    "land reclamation",
                    "water purification",
                    "community development",
                    "sustainable development goals",
                    "environmental initiative",
                    "Ghana environmental project",
                    "ecological restoration",
                    "environmental impact"
                ]}
                image="/images/Website_Impact Section1.jpg"
                url="/impact/ecorevive"
            />
            <EcoReviveHero />
            <EcoReviveProjectOverview />
            <SDGShowcase />
            <ImpactMetrics />
            <ProjectCommitment />
        </main>
    );
} 